import { createTheme } from "@mui/material/styles";

export const themeOptions = createTheme({
    palette: {
        mode: 'light',
        primary: {
          main: '#32477d',
        },
        secondary: {
          main: '#6D7785',
        },
        background: {
          default: '#E5E5E5',
        },
  },
  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },
});


